var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Label, Select as _Select } from "theme-ui";
import { FormVariants, FontWeight } from "../../index";
import { FormError } from "./index";
export const Select = (_a) => {
    var { onChange = (event) => true, hasError, errorMessage, variant = FormVariants.select, defaultValue, value } = _a, props = __rest(_a, ["onChange", "hasError", "errorMessage", "variant", "defaultValue", "value"]);
    const [newValue, setNewValue] = useState();
    const handleChange = (e) => {
        onChange && onChange(e);
        setNewValue(e.target.value);
    };
    useEffect(() => {
        if (value !== newValue)
            setNewValue(value);
    }, [value]);
    return (_jsxs(Box, { className: "form-input", sx: {
            position: "relative",
            color: variant === FormVariants.selectOutlineDark ? "white.0" : "grey.1"
        }, children: [_jsx(Label, { htmlFor: props.id, sx: {
                    width: "100%",
                    display: "inline-block",
                    position: "absolute",
                    top: "0.4375rem",
                    left: 10,
                    pl: "0.0625rem",
                    variant: "text.label3",
                    fontWeight: FontWeight.textBold,
                    transition: "all 0.1s ease-in",
                    color: variant === FormVariants.selectOutlineDark ? "white.0" : "grey.1"
                }, children: props.label }), _jsx(_Select, Object.assign({}, props, { id: props.id, name: props.name, value: newValue, sx: {
                    variant: `forms.${variant}`,
                    "& option": {
                        color: "black.1",
                        bg: "white.0"
                    }
                }, onChange: handleChange, children: props.children })), hasError && errorMessage && _jsx(FormError, { children: errorMessage })] }));
};
export default Select;
//# sourceMappingURL=Select.js.map